import { RouterModule, Routes } from "@angular/router";
import { AdminMenuWrapperComponent } from "./wrappers/admin-menu-wrapper/admin-menu-wrapper.component";
import { NgModule } from "@angular/core";
import { hasRoleGuard } from "../../../core/guards/role.guard";
import { isAdminGuard } from "../../../core/guards/isAdmin.guard";
import { OnboardingWrapperComponent } from "../../../shared/wrappers/onboarding-wrapper/onboarding-wrapper.component";
import { AdminOnboardingProfilePage } from "./pages/admin-onboarding/profile/admin-onboarding-profile.page";
import { AdminOnboardingAddressPage } from "./pages/admin-onboarding/address/admin-onboarding-address.page";
import {
  AdminOnboardingSubscriptionPage
} from "./pages/admin-onboarding/subscription/admin-onboarding-subscription.page";
import { AdminOnboardingSummaryPage } from "./pages/admin-onboarding/summary/admin-onboarding-summary.page";
import {
  AdminOnboardingPaymentSuccessPage
} from "./pages/admin-onboarding/payment-success/admin-onboarding-payment-success.page";
import {
  AdminOnboardingPaymentErrorPage
} from "./pages/admin-onboarding/payment-error/admin-onboarding-payment-error.page";
import {
  AdminOnboardingPaymentProcessingPage
} from "./pages/admin-onboarding/payment-processing/admin-onboarding-payment-processing.page";

export const ADMIN_WRAPPER_ROUTES: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full"
  },
  {
    path: "",
    component: AdminMenuWrapperComponent,
    children: [
      {
        path: "dashboard",
        loadChildren: () => import("../dashboard/dashboard.module").then(m => m.DashboardModule),
        canActivate: [hasRoleGuard(["ROLE_INSTALLER", "ROLE_CLIENT_ADMIN", "ROLE_ADMIN"])],
        title: `Back-office | Dashboard`
      },
      {
        path: "orders",
        loadChildren: () => import("../orders/orders.module").then(m => m.OrdersModule),
        canActivate: [hasRoleGuard(["ROLE_INSTALLER", "ROLE_CLIENT_ADMIN", "ROLE_ADMIN"])],
        title: `Back-office | Les commandes`
      },
      {
        path: "installations",
        loadChildren: () => import("../installations/installations.module").then(m => m.InstallationsModule),
        canActivate: [hasRoleGuard(["ROLE_INSTALLER", "ROLE_CLIENT_ADMIN", "ROLE_ADMIN"])],
        title: `Back-office | Les installations`
      },
      {
        path: "hardwares",
        loadChildren: () => import("../hardwares/hardwares.module").then(m => m.HardwaresModule),
        canActivate: [hasRoleGuard(["ROLE_INSTALLER", "ROLE_CLIENT_ADMIN", "ROLE_ADMIN"])],
        title: `Back-office | Les matériels`
      },
      {
        path: "customers",
        loadChildren: () => import("../members/members.module").then(m => m.MembersModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Les utilisateurs`
      },
      {
        path: "associations",
        loadChildren: () => import("../associations/associations.module").then(m => m.AssociationsModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Les associations`
      },
      {
        path: "admins",
        loadChildren: () => import("../admins/admins.module").then(m => m.AdminsModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Les administrateurs & installateurs`
      },
      {
        path: "subscriptions",
        loadChildren: () => import("../subscriptions/subscription.module").then(m => m.SubscriptionModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Les abonnements`
      },
      {
        path: "options",
        loadChildren: () => import("../addons/addons.module").then(m => m.AddonsModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Les options d'abonnement`
      },
      {
        path: "faq",
        loadChildren: () => import("../faqs/faqs.module").then(m => m.FaqsModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Foire aux questions`
      },
      {
        path: "tips",
        loadChildren: () => import("../tips/tips.module").then(m => m.TipsModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Les astuces`
      },
      {
        path: "notice",
        loadChildren: () => import("../notice/notice.module").then(m => m.NoticeModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Mentions légales`
      },
      {
        path: "guides",
        loadChildren: () => import("../tutorials/tutorials.module").then(m => m.TutorialsModule),
        canActivate: [isAdminGuard()]
      },
      {
        path: "legal-information",
        loadChildren: () => import("../associations/associations.module").then(m => m.AssociationsModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Les guides & tutoriels`
      },
      {
        path: "privacy-policy",
        loadChildren: () => import("../policy/policy.module").then(m => m.PolicyModule),
        canActivate: [isAdminGuard()],
        title: `Back-office | Politique de confidentialité`
      }
    ]
  },
  {
    path: "onboarding",
    component: OnboardingWrapperComponent,
    children: [
      {
        path: "profile",
        component: AdminOnboardingProfilePage,
        title: `CoucouVisio | Profil du proche`
      },
      {
        path: ":communityId/profile",
        component: AdminOnboardingProfilePage,
        title: `CoucouVisio | Profil du proche`
      },
      {
        path: "address",
        component: AdminOnboardingAddressPage,
        title: `CoucouVisio | Adresse de livraison`
      },
      {
        path: ":communityId/address",
        component: AdminOnboardingAddressPage,
        title: `CoucouVisio | Adresse de livraison`
      },
      {
        path: ":communityId/subscription",
        component: AdminOnboardingSubscriptionPage,
        title: `CoucouVisio | Abonnement`
      },
      {
        path: ":communityId/summary",
        component: AdminOnboardingSummaryPage,
        title: `CoucouVisio | Récapitulatif`
      },
      {
        path: ":communityId/payment-success",
        component: AdminOnboardingPaymentSuccessPage,
        title: `CoucouVisio | Paiement validé`
      },
      {
        path: ":communityId/payment-error",
        component: AdminOnboardingPaymentErrorPage,
        title: `CoucouVisio | Paiement refusé`
      },
      {
        path: ":communityId/payment-processing",
        component: AdminOnboardingPaymentProcessingPage,
        title: `CoucouVisio | Paiement en attente`
      }
    ]
  },
  {
    path: "**",
    redirectTo: "dashboard"
  }
];

@NgModule({
  imports: [RouterModule.forChild(ADMIN_WRAPPER_ROUTES)],
  exports: [RouterModule]
})
export class AdminSharedRoutingModule {
}
